import React, { createContext, useContext, useState, useCallback, Children } from 'react';

const FocusContext = createContext({
  isFocused: false,
  setFocused: () => {},
  focusedElement: null,
  setFocusedElement: () => {},
});

export const FocusProvider = ({ children, groupId }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [focusedElement, setFocusedElement] = useState(null);

  const setFocused = useCallback((focused, elementId = null) => {
    setIsFocused(focused);
    setFocusedElement(focused ? elementId : null);
  }, []);

  const handleSetFocusedElement = useCallback(elementId => {
    setFocusedElement(elementId);
    setIsFocused(!!elementId);
  }, []);

  const value = {
    isFocused,
    setFocused,
    focusedElement,
    setFocusedElement: handleSetFocusedElement,
    groupId,
  };

  const className = `group ${isFocused ? 'focus' : ''}`.trim();

  return (
    <FocusContext.Provider value={value}>
      {Children.map(children, child => {
        if (React.isValidElement(child)) {
          const existingClassName = child.props.className || '';
          return React.cloneElement(child, {
            className: existingClassName ? `${existingClassName} ${className}` : className,
          });
        }
        return child;
      })}
    </FocusContext.Provider>
  );
};

export const useFocusContext = () => {
  const context = useContext(FocusContext);
  return context;
};

export default FocusContext;
